// extracted by mini-css-extract-plugin
export default {"entreprise":"Footer_entreprise__B8JBc","link":"Footer_link__sgKeT"};